const BADGE_GROUPS: Array<{ badges: string[]; pill: string }> = [
  {
    badges: ["B2B SaaS", "MarTech", "Mobile App Marketing"],
    pill: "bg-blue-50 text-blue-700 ring-blue-200",
  },
  {
    badges: [
      "Live in Production",
      "143 Monthly Active Accounts",
      ">20K Audits Run",
      "10 Design Partners",
    ],
    pill: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  },
  {
    badges: ["2035 TAM $1.9–7.6B", "EU-based, US-incorporated"],
    pill: "bg-slate-100 text-slate-700 ring-slate-300",
  },
];

export default function Cover() {
  return (
    <div className="flex w-full flex-col gap-10 px-6 pt-10 pb-5 text-slate-900 md:h-full md:gap-0 md:px-24 md:pt-16 md:pb-8">
      <header className="flex">
        <img
          src="https://public.apptonomy.ai/a7y-wordmark-onlight.png"
          srcSet="https://public.apptonomy.ai/a7y-wordmark-onlight.png 1x, https://public.apptonomy.ai/a7y-wordmark-onlight_2x.png 2x, https://public.apptonomy.ai/a7y-wordmark-onlight_3x.png 3x"
          alt="Apptonomy"
          className="h-9 w-auto md:h-12"
        />
      </header>

      <div className="flex flex-col gap-8 md:flex-1 md:flex-row md:items-center md:justify-between md:gap-12">
        <div>
          <h1 className="text-4xl font-semibold leading-tight tracking-tight md:text-7xl md:leading-[1.05]">
            Pre-Seed
            <br />
            Primer Deck
          </h1>
          <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-blue-700 md:mt-8 md:text-base md:tracking-[0.25em]">
            The Constant ASO Platform
          </p>
          <p className="mt-2 text-2xl font-semibold leading-tight tracking-tight text-slate-900 md:mt-3 md:text-4xl">
            Expert ASO. Every app. Every day.
          </p>
        </div>
        {/* Right column — badge pills in three groups, hairline rule between groups */}
        <div className="flex flex-wrap items-center gap-2 md:flex-col md:items-end md:gap-2.5">
          {BADGE_GROUPS.map((group, gi) => (
            <div
              key={gi}
              className="contents md:flex md:flex-col md:items-end md:gap-2.5"
            >
              {gi > 0 ? (
                <div
                  aria-hidden="true"
                  className="hidden md:my-1.5 md:block md:h-px md:w-10 md:bg-slate-300"
                />
              ) : null}
              {group.badges.map((badge) => (
                <span
                  key={badge}
                  className={`rounded-full px-3.5 py-1 text-xs font-semibold ring-1 md:px-5 md:py-[7.5px] md:text-[17.5px]/[25px] ${group.pill}`}
                >
                  {badge}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <footer className="flex flex-col gap-4 text-sm md:flex-row md:gap-16 md:text-lg">
        <div>
          <p className="font-semibold text-slate-800">Thomas Purnell-Fisher, CEO</p>
          <p className="mt-1 text-slate-500">tpf@apptonomy.ai</p>
          <p className="text-slate-500">+31 (0)6 2343 9095 (NL / iMessage / WhatsApp)</p>
        </div>
        <div>
          <p className="font-semibold text-slate-800">Yevhen Tarasenko, CMO</p>
          <p className="mt-1 text-slate-500">yevhen@apptonomy.ai</p>
          <p className="text-slate-500">+34 627 896 205 (ES / iMessage / WhatsApp)</p>
        </div>
      </footer>
    </div>
  );
}
